export const moduleConfig = {
    entityKey: 'billable-events',
    titles: {
        singular: 'Billable Event',
        plural: 'Billable Events'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};
